import { useAuth } from '../hooks/useAuth';

/**
 * Spec 050 — shown to an admin who holds no screens at all.
 *
 * Distinct from AccessDenied, which means "you are not an admin". This one means
 * "you are an admin, but nobody has given you anything yet" — a normal state for
 * a freshly created account, so it reads as a next step rather than an error.
 */
export default function NoScreenAccess() {
  const { user, screensError, logout } = useAuth();

  return (
    <div className="admin-page">
      <div className="admin-card admin-empty-state">
        <h1 className="admin-page-title">
          {screensError ? 'Could not load your access' : 'No access assigned yet'}
        </h1>
        <p className="admin-text-muted">
          {screensError
            ? screensError
            : `You are signed in as ${user?.email ?? 'an admin'}, but no roles have been assigned to your account yet. Ask a super admin to grant you access from the Admin Roles screen.`}
        </p>
        <div className="admin-modal-footer">
          <button type="button" className="admin-btn" onClick={logout}>
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
